module.exports = __webpack_public_path__ + "media/images/icons/box-ea6066e8beced9127f71727210dc6f85.svg";